export default __webpack_public_path__ + "static/media/ZaySneaker_Wide.7562a2d6.jpg";